import { DestroyRef, effect, inject, Injectable } from '@angular/core';
import { filter, tap } from 'rxjs';
import { ServiceInventoryService, ServiceState } from '@brightside-web/desktop/data-access/service-inventory';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HomeFeedSection, HomeFeedService } from '@brightside-web/desktop/feature/home-feed';
import { CampaignsService } from './campaigns.service';
import { CampaignConfig } from '../models/campaign.models';
import { CampaignPromotionCardComponent } from '../cards/campaign-promotion-card/campaign-promotion-card.component';

@Injectable({
  providedIn: 'root'
})
export class CampaignCardsService {
  private _homeFeedService = inject(HomeFeedService);
  private _serviceInventory = inject(ServiceInventoryService);
  private readonly _destroyRef = inject(DestroyRef);
  private _campaignsService = inject(CampaignsService);
  private _previousCampaignKeys = new Set<string>();

  constructor() {
    this._serviceInventory.getService('campaigns')
      .pipe(
        filter((service) => !!service),
        tap((service) => {
          switch (service.state) {
            case ServiceState.INITIAL:
              this._campaignsService.getCampaigns();
              // this.registerHardShipActionCards(service.route || '', ServiceState.READY);
              // this.registerHardshipInitialCard();
              break;
            case ServiceState.READY:
            case ServiceState.UPLOAD:
            case ServiceState.REVIEW:
              // this.registerHardShipActionCards(service.route || '', service.state);
              break;
          }
        }),
        takeUntilDestroyed(this._destroyRef)
      ).subscribe();

    effect(() => {
      const campaigns = this._campaignsService.campaigns();
      const currentKeys = new Set(campaigns?.map((c) => c.key) ?? []);

      // Remove cards for campaigns that are no longer present
      this._previousCampaignKeys.forEach((key) => {
        if (!currentKeys.has(key)) {
          this._homeFeedService.removeHomeFeedCard(key, HomeFeedSection.PROMOTION);
        }
      });
      this._previousCampaignKeys = currentKeys;

      if (campaigns?.length) {
        campaigns.forEach((campaign, index) => {
          this._registerCampaignCard(campaign, index);
        });
      }
    }, { allowSignalWrites: true });
  }

  private _registerCampaignCard(campaign: CampaignConfig, index: number) {
    this._homeFeedService.registerHomeFeedCard({
      key: campaign.key,
      component: 'CampaignPromotionCardComponent',
      componentRef: CampaignPromotionCardComponent,
      data: campaign,
      order: index,
      section: HomeFeedSection.PROMOTION
    })
  }

}
